import { helper } from '@ember/component/helper';

export default helper(function copyKeysHelper([ object, ...keys ]) {
  const result = {};
  keys.forEach(key => {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
});
